export default __webpack_public_path__ + "img_scribbler.ae17fd.png";